import { useLabel } from "../lib/labels";
import { navigateExternal } from "../lib/postmessage";
import { Button } from "../ui";
import type { CartAddedData, CartAddedItem } from "../types";
import { AddCartDoneItem } from "./pick/pickAddCartItem";

interface Props {
  data: CartAddedData;
  sessionToken: string;
}

/** 장바구니 담기 완료 카드 — Figma 3105-17080(단건) / 2109-4779(다건).
 *  단일 카드(.cart-added) 안에 제품 행을 세로로 나열하고, 하단에 Go to Basket 1개.
 *  GR-6 다건(§3-2): items 가 있으면 리스트로 노출(최대수 제한 없음, 캐러셀 아님). */
export default function CartAddedCard({ data, sessionToken }: Props) {
  const items: CartAddedItem[] =
    data.items && data.items.length > 0
      ? data.items
      : [
          {
            sku: data.sku,
            productName: data.productName,
            image: data.image,
            price: data.price,
            quantity: data.quantity,
            badges: data.badges,
            kind: data.kind,
          },
        ];
  const addedStatusLabel = useLabel("addedToBasket", "Added to your Basket");
  const goToBasketLabel = useLabel("goToBasket", "Go to Basket");

  const handleGoToBasket = () => {
    if (!data.cartUrl) {
      console.warn(
        "[CartAddedCard] cartUrl 누락 — 서버가 build_nav_url 로 채워야 함",
      );
      return;
    }
    navigateExternal(data.cartUrl, { target: "_top" }, { sessionId: sessionToken });
  };

  return (
    <div className="ai-gp1--section">
      <h4 className="ai-gp-eligible--title">{addedStatusLabel}</h4>
      <div className="cart-added">
        <ul className="pick-list cart-added__list">
          {items.map((item, idx) => (
            <AddCartDoneItem
              key={item.sku || idx}
              item={{
                sku: item.sku || "",
                name: item.productName?.trim() || item.sku || "",
                image: item.image,
                price: item.price,
                quantity: item.quantity,
                kind: item.kind,
              }}
            />
          ))}
        </ul>
        <Button
          variant="primary"
          size="xs"
          fullWidth
          onClick={handleGoToBasket}
        >
          {goToBasketLabel}
        </Button>
      </div>
    </div>
  );
}
